/**
 * This component is the precurated list
 */

import globals from '../../common/globals';

export default {
  name: 'vx-curated-list',
  components: {},
  props: {
    // curated list details passed from parent component
    curatedList: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      globals,
    };
  },
  computed: {},
  async mounted() {},
  methods: {},
};



// WEBPACK FOOTER //
// ./src/components/view-site-content/vx-curated-list/vx-curated-list.js